// Dependencies
import { FC } from "react";

// Components
import { Typography } from "@mui/material";
import { FallbackProps } from "react-error-boundary";
import { If } from "jsx-control-statements";

// icons
import Error404 from "~/assets/icons/404-error.png";
import ErrorIcon from "~/assets/icons/error_fallback.png";
import { Button } from "../Common";

const ErrorFallback: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <If condition={error?.response?.status === 404}>
        <img alt="404 not found" src={Error404} />
        <Typography variant={"h2"}>Page not found</Typography>
      </If>
      <If condition={error?.response?.status !== 404}>
        <img alt="404 not found" src={ErrorIcon} />
        <Button variant={"text"} onClick={resetErrorBoundary}>
          Let's try again
        </Button>
        <Typography variant={"h2"}>Some thing went wrong</Typography>
        <Typography variant={"h4"}>Error: {error?.message}</Typography>
      </If>
    </div>
  );
};

export default ErrorFallback;
